import { render } from "./co-cookie-banner.vue?vue&type=template&id=40fae836&scoped=true"
import script from "./js/co-cookie-banner.js?vue&type=script&lang=js&external"
export * from "./js/co-cookie-banner.js?vue&type=script&lang=js&external"

import "./co-cookie-banner.vue?vue&type=style&index=0&id=40fae836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fae836"]])

export default __exports__